const getTeamLabel = (team) => {
  if (!team) return '-';
  if (typeof team === 'string') return team;
  return team.display_name || team.name || '-';
};

export default getTeamLabel;
